import { createContext, useContext, useEffect, useMemo, type PropsWithChildren } from 'react'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { PowerDialerListStore } from 'pages/powerDialer/pages/list/store/PowerDialerListStore'
import { useEventListPowerDialerUpdated } from 'pages/powerDialer/pages/list/events/EventListPowerDialerUpdated'

export const PowerDialerListContext = createContext<PowerDialerListStore | null>(null)

export const usePowerDialerListContext = () => {
  const context = useContext(PowerDialerListContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with PowerDialerListContext')

  return context
}

export const PowerDialerListProvider = observer(({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new PowerDialerListStore(entities), [])

  useEffect(() => store.dispose, [])

  useEventListPowerDialerUpdated(store)

  return <PowerDialerListContext.Provider value={store}>{children}</PowerDialerListContext.Provider>
})
